import { Accordion, Icon, Button, Modal } from 'semantic-ui-react';
import InputField from '../nuevoDocumento/InputField';
import ReactTooltip from 'react-tooltip';
import { ResumenDetalle } from '../../models/resumenDetalle';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { dateFormat, currencyFormat, IsNotNullOrEmptyOrUndefined } from '../../util';
import Encabezado from '../documentoElectronico/Encabezado';
import Detalle from '../documentoElectronico/Detalle';
import { connect } from 'react-redux';
import RenderResumenDocumento from '../shared/RenderResumenDocumento';
import { estadoConfirmacion } from '../../catalogos';
import { mensajeFacturaEnum } from '../../enum/index.js';

let arrayElementos = [];
const ListadoDocumentosConfirmacion = (props) => {

  const [isActiveModalRazon, setIsActiveModalRazon] = useState(false);
  const { documentos, setArray, setDocs } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const [razon, setRazon] = useState('');
  const [itemSeleccionado, setItemSeleccionado] = useState(null);

  useEffect(() => {
    arrayElementos = [];
  }, [documentos]);

  const getEstadoConfirmacion = (value) => {
    if (IsNotNullOrEmptyOrUndefined(value)) {
      return estadoConfirmacion.filter((item) => item?.value === value)[0]?.display;
    }
    return 'N/A';
  };



  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex);
  };

  const calculaTotal = (valor1, valor2) => {
    let total = parseFloat(valor1) + parseFloat(valor2);
    total = isNaN(total) ? 0 : total.toFixed(3);
    return total;
  };

  const aceptarRazon = () => {
    if (IsNotNullOrEmptyOrUndefined(razon)) {
      let item = itemSeleccionado;
      setItemSeleccionado(null);
      setIsActiveModalRazon(false);
      if (IsNotNullOrEmptyOrUndefined(existeFacturaAceptar(arrayElementos, item.Clave))) {
        arrayElementos.map((fac) => {
          if (fac.Clave === item.Clave) {
            fac.DetalleMensaje = razon;
          }
        });
        setArray([...arrayElementos]);
      } else {
        confirmarXml(item, item.Mensaje, razon);
        setArray([...arrayElementos]);
      }
      setRazon('');
    }
  };

  const rechazarRazon = () => {
    setRazon('');
    let item = itemSeleccionado;
    setIsActiveModalRazon(false);
    confirmarXml(item, item.Mensaje, razon);
    setItemSeleccionado(null);
  };
  const confirmarXml = (item, estado, razonR) => {

    const Elemento = {
      "Receptor": {
        "CorreoElectronico": item?.Emisor?.CorreoElectronico,
        "CorreosAdicionales": item?.Emisor?.CorreosAdicionales,

        "IdentificacionExtranjero": item?.Emisor?.IdentificacionExtranjero,
        "OtrasSenasExtranjero": item?.Emisor?.OtrasSenasExtranjero,

        "Nombre": item?.Emisor?.Nombre,
        "Identificacion": {
          "Tipo": item?.Emisor?.Identificacion?.Tipo,
          "Numero": item?.Emisor?.Identificacion?.Numero
        },
        "NombreComercial": item?.Emisor?.NombreComercial,
        "Ubicacion": {
          "Provincia": item?.Emisor?.Ubicacion?.Provincia,
          "Canton": item?.Emisor?.Ubicacion?.Canton,
          "Distrito": item?.Emisor?.Ubicacion?.Distrito,
          "Barrio": item?.Emisor?.Ubicacion?.Barrio,
          "OtrasSenas": item?.Emisor?.Ubicacion?.OtrasSenas
        },
        "Telefono": {
          "CodigoPais": item?.Emisor?.Telefono?.CodigoPais,
          "NumTelefono": item?.Emisor?.Telefono?.NumTelefono
        },
        "Fax": {
          "CodigoPais": item?.Emisor?.Fax?.CodigoPais,
          "NumTelefono": item?.Emisor?.Fax?.NumTelefono
        },
      },
      "Clave": item?.Clave,
      "CondicionVenta": item?.CondicionVenta,
      "FechaEmisionDoc": moment().format('YYYY-MM-DD HH:mm'),
      "NumeroCedulaEmisor": item?.Emisor?.Identificacion?.Numero,
      "Mensaje": estado,
      "DetalleMensaje": razonR,
      "MontoTotalImpuesto": item?.ResumenFactura?.TotalImpuesto,
      "CodigoActividad": item?.CodigoActividad,
      "TipoFactura": 0,
      "TotalFactura": item.ResumenFactura?.TotalComprobante,
      "NumeroCedulaReceptor": item?.Receptor?.Identificacion?.Numero,
      "NumeroConsecutivoReceptor": item?.NumeroConsecutivo,
      "MensajeError": "",
      "FechaEmisionFactura": item?.FechaEmision,
      "TipoMoneda": "",
      "TipoCambio": "1",
      "ResumenImpuestos": null
    };

    if (IsNotNullOrEmptyOrUndefined(item.ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda)) {
      Elemento.TipoMoneda = item?.ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda;
      if (Elemento.TipoMoneda === "CRC") {
        Elemento.TipoCambio = 1;
      } else {
        Elemento.TipoCambio = item?.ResumenFactura?.CodigoTipoMoneda?.TipoCambio;
      }
    } else {
      Elemento.TipoMoneda = "CRC";
      Elemento.TipoCambio = 1;
    }
    const ResumenImpuestos = [];
    const DetalleComprasConfirmadas = [];

    item.DetalleServicio.LineaDetalle.map((detalle) => {
      let impuesto = detalle.Impuesto;
      const detalleCompra = {
        Clave: item?.Clave,
        Detalle: item?.Detalle,
        MontoImpuesto: impuesto?.Monto,
        CodigoTarifa: impuesto?.CodigoTarifa,
      };
      DetalleComprasConfirmadas.push(detalleCompra);

      if (IsNotNullOrEmptyOrUndefined(impuesto)) {
        if (IsNotNullOrEmptyOrUndefined(existe(ResumenImpuestos, impuesto.CodigoTarifa === undefined ? "00" : impuesto.CodigoTarifa))) {
          ResumenImpuestos.map((resumen) => {
            if (resumen.CodigoTarifa === impuesto?.CodigoTarifa ) {
               let suma1 = 0;
               let suma2 = 0
              if(impuesto?.Exoneracion != null & impuesto.Exoneracion.MontoExoneracion > 0){
                suma1 = calculaTotal(parseFloat(impuesto?.Monto) - parseFloat(impuesto.Exoneracion.MontoExoneracion), resumen.Monto);
                suma2 = calculaTotal(parseFloat(resumen.SubTotalLinea), detalle?.SubTotal);
              }
              else {
                suma1 = calculaTotal(impuesto?.Monto, resumen.Monto);
                suma2 = calculaTotal(resumen.SubTotalLinea, detalle?.SubTotal);
              }

              resumen.Monto = suma1;
              resumen.SubTotalLinea = suma2;
            }
          })
        } else {
            let suma1 = 0;
            let suma2 = 0
            if(impuesto?.Exoneracion != null & impuesto.Exoneracion.MontoExoneracion > 0){
              suma1 = parseFloat(impuesto?.Monto) - parseFloat(impuesto.Exoneracion.MontoExoneracion);
              suma2 = parseFloat(detalle?.SubTotal);
            }else {
              suma1 = impuesto?.Monto;
              suma2 = detalle?.SubTotal;
            }
            var Resumen = {
              ...ResumenDetalle,
              "CodigoTarifa": impuesto.CodigoTarifa === undefined ? "00" : impuesto.CodigoTarifa,
              "Tarifa": isNaN(impuesto.Tarifa) ? "0" : impuesto.Tarifa,
              "UnidadMedida": detalle.UnidadMedida,
              "Clave": item?.Clave,
              "Monto": parseFloat(suma1).toFixed(3),
              "SubTotalLinea": parseFloat(suma2).toFixed(3)
            };
            ResumenImpuestos.push(Resumen);
        }
      }
    })
    Elemento.ResumenImpuestos = ResumenImpuestos;
    Elemento.DetalleComprasConfirmadas = DetalleComprasConfirmadas;
    arrayElementos.push(Elemento);
    setArray([...arrayElementos]);
  };

  const cambiarRazon = (texto) => {
    setRazon(texto);
  };

  const existe = (array, dato) => {
    return array.filter((item) => item.CodigoTarifa === dato)[0];
  };
  const rechazo = (item) => {

    item.Mensaje = mensajeFacturaEnum.Rechazado;
    setItemSeleccionado(item);
    setIsActiveModalRazon(true);

  };
  const existeFacturaAceptar = (array, dato) => {
    return array.filter((item) => item.Clave === dato)[0];
  };

  const aceptar = (item) => {
    if (IsNotNullOrEmptyOrUndefined(existeFacturaAceptar(arrayElementos, item.Clave))) {
      arrayElementos.map((fac) => {
        if (fac.Clave === item.Clave) {
          fac.Mensaje = mensajeFacturaEnum.Aceptado;
          fac.DetalleMensaje = "Aceptado";
        }
      });
      setArray([...arrayElementos]);
    } else {
      confirmarXml(item, 1, "Aceptado");
      setArray([...arrayElementos]);
    }
  }

  const aceptarParcial = (item) => {

    item.Mensaje = mensajeFacturaEnum.AceptadoPacial;
    setItemSeleccionado(item);
    setIsActiveModalRazon(true);
  };

  const eliminarFactura = (item) => {
    let docs = documentos.filter(fact => fact.Clave !== item.Clave);
    setDocs(docs);
  };

  const renderTitle = (item) => {
    const consecutivo = item.NumeroConsecutivo.slice(10, 20);
    let className = '';

    if (item.Estado === "Aceptado" || item.Estado === "0" || item.Estado === "1" || item.Estado === "3" || item.Estado === "4") {
      className = 'aceptado';
    } else {
      className = 'rechazado';
    }
    return (
      <>
        <div className="ui stackable row grid desktop">
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <Icon name='dropdown' />
                <span className="header-title">Consecutivo:</span>
              </div>
              <div className="sixteen wide">
                <span className={className}>{`# ${consecutivo} - ${IsNotNullOrEmptyOrUndefined(item.Estado) ? getEstadoConfirmacion(item.Estado) : ""}`}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Nombre Emisor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item.Emisor?.Nombre}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Nombre Receptor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item.Receptor.Nombre}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Cédula Receptor:</span>
              </div>
              <div className="sixteen wide">
                <span>{item.Receptor?.Identificacion?.Numero}</span>
              </div>
            </div>
          </div>
          <div className="four wide column">
            <form className="ui form">
              <div className="grouped fields" >
                <span className="header-title"> Selecciona una opcion:</span>
                <div className="field opciones">
                  <label ><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="1" onClick={() => aceptar(item)} /> Aceptar</label>
                </div>
                <div className="field opciones">
                  <label><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="2" onClick={() => aceptarParcial(item)} /> Aceptar Parcial</label>
                </div>
                <div className="field opciones">
                  <label><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="3" onClick={() => rechazo(item)} /> Rechazar</label>
                </div>
              </div>
            </form>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Fecha:</span>
              </div>
              <div className="sixteen wide">
                <span>{dateFormat(item.FechaEmision)}</span>
              </div>
            </div>
          </div>

          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Monto Impuestos: </span>
              </div>
              <div className="sixteen wide">
                <span>{currencyFormat(item.ResumenFactura?.TotalImpuesto)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Monto Exonerado: </span>
              </div>
              <div className="sixteen wide">
                <span>{currencyFormat(item.ResumenFactura?.TotalExonerado)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <span className="header-title">Monto Total: </span>
              </div>
              <div className="sixteen wide">
                <span>{currencyFormat(item.ResumenFactura?.TotalComprobante)}</span>
              </div>
            </div>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <Icon data-tip="Eliminar" onClick={() => eliminarFactura(item)} className="eliminar-producto" name="trash" />< ReactTooltip />
              </div>
            </div>
          </div>
        </div>
        <div className="ui stackable row grid responsive">
          <div className="sixteen wide column">
            <Icon name='dropdown' />
            <span className={className}>{IsNotNullOrEmptyOrUndefined(item.Estado) ? getEstadoConfirmacion(item.Estado) : ""}</span>
          </div>
          <div className="sixteen wide column">
            <span>{`Consecutivo: ${consecutivo}`}</span>
          </div>
          <div className="sixteen wide column">
            <span>{`Fecha: ${dateFormat(item.FechaEmision)}`}</span>
          </div>
          <div className="sixteen wide column">
            <span>Nombre: {item.Receptor.Nombre}</span>
          </div>
          <div className="four wide column">
            <form className="ui form">
              <div className="grouped fields" >
                <span className="header-title"> Selecciona una opcion:</span>
                <div className="field opciones">
                  <label ><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="1" onClick={() => aceptar(item)} /> Aceptar</label>
                </div>
                <div className="field opciones">
                  <label><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="2" onClick={() => aceptarParcial(item)} /> Aceptar Parcial</label>
                </div>
                <div className="field opciones">
                  <label><input disabled={IsNotNullOrEmptyOrUndefined(item.Estado) ? true : false} type="radio" name="opcion" value="3" onClick={() => rechazo(item)} /> Rechazar</label>
                </div>
              </div>
            </form>
          </div>
          <div className="three wide column">
            <div className="row">
              <div className="sixteen wide">
                <Icon data-tip="Eliminar" onClick={() => eliminarFactura(item)} className="eliminar-producto" name="trash" />< ReactTooltip />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="ui listado-documentosconfirmacion-section">
      <Modal
        centered={false}
        size="small"
        open={isActiveModalRazon}
        onClose={() => setIsActiveModalRazon(false)}
      >
        <Modal.Header>Razón de Rechazo</Modal.Header>
        <Modal.Content>

          {<InputField
            rows="4"
            cols="50"
            maxLength="180"
            onChange={(e) => cambiarRazon(e.target.value)}
            placeholder="Escriba la Razón de Rechazo"
            type="textArea"
          />
          }

        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => rechazarRazon()}>
            Cerrar
          </Button>
          <Button className="ui blue inline button " onClick={() => aceptarRazon()}>
            Aceptar
          </Button>
        </Modal.Actions>
      </Modal>
      <Accordion fluid styled>
        {
          documentos.map((item, index) => {
            return (
              <div key={index}>
                <Accordion.Title
                  active={activeIndex === index}
                  index={index}
                  onClick={handleClick}>

                  {renderTitle(item)}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index}>
                  <div className="ui segment accordion-content">
                    <Encabezado data={item} />
                    <Detalle detalle={item.DetalleServicio.LineaDetalle} />

                    <div className="ui stackable two column grid resumen-document">
                      <div className="column wide"> <div>
                          Notas adicionales:
                        </div>
                          <div>{item.Otros?.OtroTexto}</div> 
                        </div>
                      <div className="column wide right aligned">
                        <RenderResumenDocumento ResumenFactura={item.ResumenFactura} />
                      </div>
                    </div>

                  </div>
                </Accordion.Content>
              </div>
            )
          })}
      </Accordion>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps, {
})(ListadoDocumentosConfirmacion);